export default "__VITE_ASSET__BN7j7cmh__"